/** */
import cx from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import ContextMenu from 'app/shared/datatable/context-menu/context-menu';
import GmModal from 'app/shared/modal/modal';
import Breadcrumbs from 'app/shared/breadcrumbs/breadcrumbs';
import { Icon } from 'assets/icons';
import styles from './header.module.css';
import useScreenSize from 'hooks/size';
import { Button } from 'app/shared/button';
import { AIAssistantArea } from '../ai-assistant';
import { useCreateOrganization } from 'contexts/organization';

const MemberAreaHeader = ({ onHamburgerClick }) => {
  const { isMobile } = useScreenSize();

  const { page_title } = useSelector((state) => state.header);
  const [show_ai_modal, setShowAIModal] = useState(false);
  const { openCreateOrganization } = useCreateOrganization();

  const create_actions = [
    [
      {
        label: (
          <span>
            <Icon width={16} height={16} name="groups" />
            Create organisation
          </span>
        ),
        value: 'create_organisation'
      }
    ]
  ];

  const handleCreateAction = (data) => {
    if (typeof data !== 'string') return;

    switch (data.toLowerCase()) {
      case 'create_organisation':
        openCreateOrganization();
        break;
    }
  };

  return (
    <div className={cx(styles.bgColor)}>
      <header className={cx(styles.wrapper, 'shadow-sd')}>
        <div>
          <div className={styles.pageTitle}>
            <span className={styles.menuIcon} onClick={onHamburgerClick}>
              <Icon name="menu" />
            </span>

            {page_title?.length && (
              <span className={styles.title}>
                <Breadcrumbs crumbs={page_title} />
              </span>
            )}
          </div>

          <div className={styles.actions}>
            <span className={styles.tourAnchor} data-tour="ai-assistant">
              <Button
                text={isMobile ? '' : 'AI Assistant'}
                icon_name="ai"
                className={styles.aiButton}
                onClick={() => setShowAIModal(true)}
              />
            </span>
            <span className={styles.tourAnchor} data-tour="quick-actions">
              <ContextMenu
                actions={create_actions.filter((action) => !action.hidden)}
                callback={handleCreateAction}
                text={
                  <div className={styles.greenBadge}>
                    <Icon name="add" />
                    <span className={styles.quickActionText}>Quick Actions</span>
                  </div>
                }
              />
            </span>
          </div>
        </div>
      </header>
      <div>
        <GmModal
          bodyClassName={styles.aiModal}
          title="AI Assistant"
          position="right"
          show_title
          show_modal={show_ai_modal}
          onClose={() => setShowAIModal(false)}
        >
          <AIAssistantArea />
        </GmModal>
      </div>
    </div>
  );
};

export default MemberAreaHeader;
